/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse__deleted_boolean__ } from '../models/ControllerResponse__deleted_boolean__';
import type { ControllerResponse__email_string_schedulesModified_number__ } from '../models/ControllerResponse__email_string_schedulesModified_number__';
import type { ControllerResponse__enabled_boolean__ } from '../models/ControllerResponse__enabled_boolean__';
import type { ControllerResponse__name_string__ } from '../models/ControllerResponse__name_string__';
import type { ControllerResponse__promoted_boolean__ } from '../models/ControllerResponse__promoted_boolean__';
import type { ControllerResponse__successCount_number_failedUserIds_string_Array__ } from '../models/ControllerResponse__successCount_number_failedUserIds_string_Array__';
import type { ControllerResponse_AdminApiUsage_Array_ } from '../models/ControllerResponse_AdminApiUsage_Array_';
import type { ControllerResponse_AdminInPortfolioStats_Array_ } from '../models/ControllerResponse_AdminInPortfolioStats_Array_';
import type { ControllerResponse_AdminUser_ } from '../models/ControllerResponse_AdminUser_';
import type { ControllerResponse_AdminUser_Array_ } from '../models/ControllerResponse_AdminUser_Array_';
import type { ControllerResponse_boolean_ } from '../models/ControllerResponse_boolean_';
import type { ControllerResponse_DatasetAttributes_ } from '../models/ControllerResponse_DatasetAttributes_';
import type { ControllerResponse_DebugProperty_Array_ } from '../models/ControllerResponse_DebugProperty_Array_';
import type { ControllerResponse_ExcelTemplate_Array_ } from '../models/ControllerResponse_ExcelTemplate_Array_';
import type { ControllerResponse_GroupAttributes_Array_ } from '../models/ControllerResponse_GroupAttributes_Array_';
import type { ControllerResponse_MarketAnalyticsSubscriptionAttributes_ } from '../models/ControllerResponse_MarketAnalyticsSubscriptionAttributes_';
import type { ControllerResponse_null_ } from '../models/ControllerResponse_null_';
import type { ControllerResponse_number_or_null_ } from '../models/ControllerResponse_number_or_null_';
import type { ControllerResponse_OrganizationAttributes_and__given_name_string_family_name_string_email_string__Array_ } from '../models/ControllerResponse_OrganizationAttributes_and__given_name_string_family_name_string_email_string__Array_';
import type { ControllerResponse_OrganizationAttributes_or_null_ } from '../models/ControllerResponse_OrganizationAttributes_or_null_';
import type { ControllerResponse_PropertyReportSubscriptionAttributes_ } from '../models/ControllerResponse_PropertyReportSubscriptionAttributes_';
import type { ControllerResponse_PropertyReportSubscriptionAttributes_Array_ } from '../models/ControllerResponse_PropertyReportSubscriptionAttributes_Array_';
import type { ControllerResponse_RentRollAttributes_ } from '../models/ControllerResponse_RentRollAttributes_';
import type { ControllerResponse_ReportResult_ } from '../models/ControllerResponse_ReportResult_';
import type { ControllerResponse_SimpleStripeUser_Array_ } from '../models/ControllerResponse_SimpleStripeUser_Array_';
import type { ControllerResponse_string_ } from '../models/ControllerResponse_string_';
import type { ControllerResponse_Subscription_ } from '../models/ControllerResponse_Subscription_';
import type { ControllerResponse_Subscription_Array_ } from '../models/ControllerResponse_Subscription_Array_';
import type { ControllerResponse_Subscription_or_null_ } from '../models/ControllerResponse_Subscription_or_null_';
import type { ControllerResponse_TemplateAIAttributes_ } from '../models/ControllerResponse_TemplateAIAttributes_';
import type { ControllerResponse_TemplateAIAttributes_Array_ } from '../models/ControllerResponse_TemplateAIAttributes_Array_';
import type { ControllerResponse_UserAttributes_Array_ } from '../models/ControllerResponse_UserAttributes_Array_';
import type { CreateGroupAttributes } from '../models/CreateGroupAttributes';
import type { DatasetPayload } from '../models/DatasetPayload';
import type { GroupAttributes } from '../models/GroupAttributes';
import type { NewClient } from '../models/NewClient';
import type { NewUser } from '../models/NewUser';
import type { Omit_OrganizationAttributes_id_ } from '../models/Omit_OrganizationAttributes_id_';
import type { Pick_UserAttributes_id_or_email_or_created_on_or_organization_id_or_given_name_or_family_name_or_picture_or_group_id_ } from '../models/Pick_UserAttributes_id_or_email_or_created_on_or_organization_id_or_given_name_or_family_name_or_picture_or_group_id_';
import type { Section } from '../models/Section';
import type { UpdateGroupAttributes } from '../models/UpdateGroupAttributes';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdminService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ControllerResponse_AdminUser_Array_ Ok
     * @throws ApiError
     */
    public getAllUsers(): CancelablePromise<ControllerResponse_AdminUser_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/users',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_AdminUser_ Ok
     * @throws ApiError
     */
    public createNewUser(
        requestBody: NewUser,
    ): CancelablePromise<ControllerResponse_AdminUser_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/users',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ControllerResponse_SimpleStripeUser_Array_ Ok
     * @throws ApiError
     */
    public getAllSimpleStripeUsers(): CancelablePromise<ControllerResponse_SimpleStripeUser_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/stripe_users',
        });
    }
    /**
     * @param productId
     * @returns ControllerResponse_OrganizationAttributes_and__given_name_string_family_name_string_email_string__Array_ Ok
     * @throws ApiError
     */
    public getOrganizationsByProductId(
        productId?: string,
    ): CancelablePromise<ControllerResponse_OrganizationAttributes_and__given_name_string_family_name_string_email_string__Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/organizations',
            query: {
                'productId': productId,
            },
        });
    }
    /**
     * @param reportId
     * @returns ControllerResponse_PropertyReportSubscriptionAttributes_ Ok
     * @throws ApiError
     */
    public copyPropertyReport(
        reportId: number,
    ): CancelablePromise<ControllerResponse_PropertyReportSubscriptionAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/reports/{reportId}/copy',
            path: {
                'reportId': reportId,
            },
        });
    }
    /**
     * @param reportId
     * @returns ControllerResponse_MarketAnalyticsSubscriptionAttributes_ Ok
     * @throws ApiError
     */
    public copyMarketAnalytics(
        reportId: number,
    ): CancelablePromise<ControllerResponse_MarketAnalyticsSubscriptionAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/market_analytics/{reportId}/copy',
            path: {
                'reportId': reportId,
            },
        });
    }
    /**
     * @param datasetId
     * @returns ControllerResponse_DatasetAttributes_ Created
     * @throws ApiError
     */
    public copyDataset(
        datasetId: number,
    ): CancelablePromise<ControllerResponse_DatasetAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/datasets/{datasetId}/copy',
            path: {
                'datasetId': datasetId,
            },
        });
    }
    /**
     * @param rentRollId
     * @returns ControllerResponse_RentRollAttributes_ Created
     * @throws ApiError
     */
    public copyRentRoll(
        rentRollId: number,
    ): CancelablePromise<ControllerResponse_RentRollAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/rent_rolls/{rentRollId}/copy',
            path: {
                'rentRollId': rentRollId,
            },
        });
    }
    /**
     * @param reportId
     * @returns ControllerResponse_ReportResult_ Ok
     * @throws ApiError
     */
    public getReport(
        reportId: number,
    ): CancelablePromise<ControllerResponse_ReportResult_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/reports/{reportId}',
            path: {
                'reportId': reportId,
            },
        });
    }
    /**
     * @param userId
     * @returns ControllerResponse_UserAttributes_Array_ Ok
     * @throws ApiError
     */
    public listOrganizationMembers(
        userId: string,
    ): CancelablePromise<ControllerResponse_UserAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/organization_members/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param organizationId
     * @param userId
     * @returns ControllerResponse_PropertyReportSubscriptionAttributes_Array_ Ok
     * @throws ApiError
     */
    public listOrganizationReports(
        organizationId: number,
        userId: string,
    ): CancelablePromise<ControllerResponse_PropertyReportSubscriptionAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/organization_reports/{organizationId}/{userId}',
            path: {
                'organizationId': organizationId,
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @param requestBody
     * @returns ControllerResponse_null_ Ok
     * @throws ApiError
     */
    public removeFromOrganization(
        userId: string,
        requestBody: {
            transfer_user_id?: string;
            user_id: string;
        },
    ): CancelablePromise<ControllerResponse_null_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/remove_from_organization/{userId}',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param userId
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public getOrganization(
        userId: string,
    ): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/organization/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @param id
     * @param requestBody
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public patchOrganization(
        userId: string,
        id: number,
        requestBody: Omit_OrganizationAttributes_id_,
    ): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/organization/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public pauseOrganization(
        id: number,
    ): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/pause_organization',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @param userId
     * @param extension
     * @returns any Ok
     * @throws ApiError
     */
    public extendLastSub(
        userId: string,
        extension: number,
    ): CancelablePromise<{
        data: number | null;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/organization/{userId}/extend_last_subscription',
            path: {
                'userId': userId,
            },
            query: {
                'extension': extension,
            },
        });
    }
    /**
     * @param subscriptionId
     * @param requestBody
     * @returns ControllerResponse_Subscription_ Ok
     * @throws ApiError
     */
    public patchSubscription(
        subscriptionId: string,
        requestBody: {
            trialEnd?: string | null;
            products: Array<{
                quantity?: number;
                productId: string;
            }>;
        },
    ): CancelablePromise<ControllerResponse_Subscription_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/subscriptions/{subscriptionId}',
            path: {
                'subscriptionId': subscriptionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param userId
     * @param requestBody
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public invitePeople(
        userId: string,
        requestBody: {
            emails: Array<string>;
        },
    ): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/invite_people/{userId}',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param userId
     * @param email
     * @returns ControllerResponse_number_or_null_ Ok
     * @throws ApiError
     */
    public resendInviteEmail(
        userId: string,
        email: string,
    ): CancelablePromise<ControllerResponse_number_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/resend_invite_email/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'email': email,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public createNewClient(
        requestBody: NewClient,
    ): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/new_client',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_DebugProperty_Array_ Ok
     * @throws ApiError
     */
    public debugProperties(
        requestBody: {
            ids: Array<string>;
        },
    ): CancelablePromise<ControllerResponse_DebugProperty_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/debug_properties',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param userId
     * @returns ControllerResponse_Subscription_Array_ Ok
     * @throws ApiError
     */
    public getCustomerSubscriptions(
        userId: string,
    ): CancelablePromise<ControllerResponse_Subscription_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/subscriptions/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @returns ControllerResponse_Subscription_Array_ Ok
     * @throws ApiError
     */
    public getChildrenSubscriptions(
        userId: string,
    ): CancelablePromise<ControllerResponse_Subscription_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/child_subscriptions/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @param subscriptionId
     * @returns ControllerResponse_Subscription_or_null_ Ok
     * @throws ApiError
     */
    public closeChildAccount(
        userId: string,
        subscriptionId: string,
    ): CancelablePromise<ControllerResponse_Subscription_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/close_child_account/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'subscriptionId': subscriptionId,
            },
        });
    }
    /**
     * @param userId
     * @param subscriptionId
     * @returns ControllerResponse_Subscription_or_null_ Ok
     * @throws ApiError
     */
    public keepChildAccount(
        userId: string,
        subscriptionId: string,
    ): CancelablePromise<ControllerResponse_Subscription_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/keep_child_account/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'subscriptionId': subscriptionId,
            },
        });
    }
    /**
     * @param days
     * @returns ControllerResponse_AdminApiUsage_Array_ Ok
     * @throws ApiError
     */
    public getApiUsage(
        days: number,
    ): CancelablePromise<ControllerResponse_AdminApiUsage_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/api_usage',
            query: {
                'days': days,
            },
        });
    }
    /**
     * @returns ControllerResponse_AdminInPortfolioStats_Array_ Ok
     * @throws ApiError
     */
    public getInPortfolioStats(): CancelablePromise<ControllerResponse_AdminInPortfolioStats_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/in_portfolio_stats',
        });
    }
    /**
     * @param organizationId
     * @returns ControllerResponse_GroupAttributes_Array_ Ok
     * @throws ApiError
     */
    public getOrganizationGroups(
        organizationId: number,
    ): CancelablePromise<ControllerResponse_GroupAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/organization/{organizationId}/group',
            path: {
                'organizationId': organizationId,
            },
        });
    }
    /**
     * @param organizationId
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public createOrganizationGroup(
        organizationId: number,
        requestBody: CreateGroupAttributes,
    ): CancelablePromise<{
        data: GroupAttributes;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/organization/{organizationId}/group',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param organizationId
     * @returns any Ok
     * @throws ApiError
     */
    public createOrganizationGroupDefault(
        organizationId: number,
    ): CancelablePromise<{
        data: GroupAttributes;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/organization/{organizationId}/groupdefault',
            path: {
                'organizationId': organizationId,
            },
        });
    }
    /**
     * @param groupId
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public updateOrganizationGroup(
        groupId: number,
        requestBody: UpdateGroupAttributes,
    ): CancelablePromise<{
        data: {
            can_create_new_developments?: boolean;
            can_create_market_analytics?: boolean;
            can_create_query_builder_datasets?: boolean;
            can_edit_property_reports?: boolean;
            can_create_property_reports?: boolean;
            columns: Array<'property_grid.similarity' | 'property_grid.estimated_occupancy' | 'property_grid.exposure_percent' | 'property_grid.year_built' | 'property_grid.number_units' | 'property_grid.number_stories' | 'property_grid.number_leased' | 'property_grid.currently_available' | 'property_grid.days_on_market' | 'property_grid.min_sqft' | 'property_grid.sqft' | 'property_grid.max_sqft' | 'property_grid.min_market_rent' | 'property_grid.market_rent' | 'property_grid.max_market_rent' | 'property_grid.rent_psf' | 'property_grid.effective_rent' | 'property_grid.effective_rent_psf' | 'property_grid.concession_amount' | 'property_grid.total_concession_amount' | 'property_grid.concession_percent' | 'property_grid.trend' | 'property_grid.label' | 'property_grid.address' | 'property_grid.avg_rent' | 'property_grid.actions' | 'property_grid.number_listings' | 'property_grid.renewal_percent' | 'property_grid.tradeout_percent' | 'property_grid.number_apps_to_cancels' | 'property_grid.cancel_percent' | 'property_grid.leased_date' | 'property_grid.bed' | 'property_grid.floorplan_name' | 'amenities.similarity' | 'amenities.estimated_occupancy' | 'amenities.exposure_percent' | 'amenities.year_built' | 'amenities.number_units' | 'amenities.number_stories' | 'amenities.number_leased' | 'amenities.currently_available' | 'amenities.days_on_market' | 'amenities.min_sqft' | 'amenities.sqft' | 'amenities.max_sqft' | 'amenities.min_market_rent' | 'amenities.market_rent' | 'amenities.max_market_rent' | 'amenities.rent_psf' | 'amenities.effective_rent' | 'amenities.effective_rent_psf' | 'amenities.concession_amount' | 'amenities.total_concession_amount' | 'amenities.concession_percent' | 'amenities.trend' | 'amenities.label' | 'amenities.address' | 'amenities.avg_rent' | 'amenities.actions' | 'amenities.number_listings' | 'amenities.renewal_percent' | 'amenities.tradeout_percent' | 'amenities.number_apps_to_cancels' | 'amenities.cancel_percent' | 'amenities.leased_date' | 'amenities.bed' | 'amenities.floorplan_name' | 'building_information.similarity' | 'building_information.estimated_occupancy' | 'building_information.exposure_percent' | 'building_information.year_built' | 'building_information.number_units' | 'building_information.number_stories' | 'building_information.number_leased' | 'building_information.currently_available' | 'building_information.days_on_market' | 'building_information.min_sqft' | 'building_information.sqft' | 'building_information.max_sqft' | 'building_information.min_market_rent' | 'building_information.market_rent' | 'building_information.max_market_rent' | 'building_information.rent_psf' | 'building_information.effective_rent' | 'building_information.effective_rent_psf' | 'building_information.concession_amount' | 'building_information.total_concession_amount' | 'building_information.concession_percent' | 'building_information.trend' | 'building_information.label' | 'building_information.address' | 'building_information.avg_rent' | 'building_information.actions' | 'building_information.number_listings' | 'building_information.renewal_percent' | 'building_information.tradeout_percent' | 'building_information.number_apps_to_cancels' | 'building_information.cancel_percent' | 'building_information.leased_date' | 'building_information.bed' | 'building_information.floorplan_name' | 'chart_compare.similarity' | 'chart_compare.estimated_occupancy' | 'chart_compare.exposure_percent' | 'chart_compare.year_built' | 'chart_compare.number_units' | 'chart_compare.number_stories' | 'chart_compare.number_leased' | 'chart_compare.currently_available' | 'chart_compare.days_on_market' | 'chart_compare.min_sqft' | 'chart_compare.sqft' | 'chart_compare.max_sqft' | 'chart_compare.min_market_rent' | 'chart_compare.market_rent' | 'chart_compare.max_market_rent' | 'chart_compare.rent_psf' | 'chart_compare.effective_rent' | 'chart_compare.effective_rent_psf' | 'chart_compare.concession_amount' | 'chart_compare.total_concession_amount' | 'chart_compare.concession_percent' | 'chart_compare.trend' | 'chart_compare.label' | 'chart_compare.address' | 'chart_compare.avg_rent' | 'chart_compare.actions' | 'chart_compare.number_listings' | 'chart_compare.renewal_percent' | 'chart_compare.tradeout_percent' | 'chart_compare.number_apps_to_cancels' | 'chart_compare.cancel_percent' | 'chart_compare.leased_date' | 'chart_compare.bed' | 'chart_compare.floorplan_name' | 'comp_map.similarity' | 'comp_map.estimated_occupancy' | 'comp_map.exposure_percent' | 'comp_map.year_built' | 'comp_map.number_units' | 'comp_map.number_stories' | 'comp_map.number_leased' | 'comp_map.currently_available' | 'comp_map.days_on_market' | 'comp_map.min_sqft' | 'comp_map.sqft' | 'comp_map.max_sqft' | 'comp_map.min_market_rent' | 'comp_map.market_rent' | 'comp_map.max_market_rent' | 'comp_map.rent_psf' | 'comp_map.effective_rent' | 'comp_map.effective_rent_psf' | 'comp_map.concession_amount' | 'comp_map.total_concession_amount' | 'comp_map.concession_percent' | 'comp_map.trend' | 'comp_map.label' | 'comp_map.address' | 'comp_map.avg_rent' | 'comp_map.actions' | 'comp_map.number_listings' | 'comp_map.renewal_percent' | 'comp_map.tradeout_percent' | 'comp_map.number_apps_to_cancels' | 'comp_map.cancel_percent' | 'comp_map.leased_date' | 'comp_map.bed' | 'comp_map.floorplan_name' | 'estimated_unit_mix.similarity' | 'estimated_unit_mix.estimated_occupancy' | 'estimated_unit_mix.exposure_percent' | 'estimated_unit_mix.year_built' | 'estimated_unit_mix.number_units' | 'estimated_unit_mix.number_stories' | 'estimated_unit_mix.number_leased' | 'estimated_unit_mix.currently_available' | 'estimated_unit_mix.days_on_market' | 'estimated_unit_mix.min_sqft' | 'estimated_unit_mix.sqft' | 'estimated_unit_mix.max_sqft' | 'estimated_unit_mix.min_market_rent' | 'estimated_unit_mix.market_rent' | 'estimated_unit_mix.max_market_rent' | 'estimated_unit_mix.rent_psf' | 'estimated_unit_mix.effective_rent' | 'estimated_unit_mix.effective_rent_psf' | 'estimated_unit_mix.concession_amount' | 'estimated_unit_mix.total_concession_amount' | 'estimated_unit_mix.concession_percent' | 'estimated_unit_mix.trend' | 'estimated_unit_mix.label' | 'estimated_unit_mix.address' | 'estimated_unit_mix.avg_rent' | 'estimated_unit_mix.actions' | 'estimated_unit_mix.number_listings' | 'estimated_unit_mix.renewal_percent' | 'estimated_unit_mix.tradeout_percent' | 'estimated_unit_mix.number_apps_to_cancels' | 'estimated_unit_mix.cancel_percent' | 'estimated_unit_mix.leased_date' | 'estimated_unit_mix.bed' | 'estimated_unit_mix.floorplan_name' | 'exposure_chart.similarity' | 'exposure_chart.estimated_occupancy' | 'exposure_chart.exposure_percent' | 'exposure_chart.year_built' | 'exposure_chart.number_units' | 'exposure_chart.number_stories' | 'exposure_chart.number_leased' | 'exposure_chart.currently_available' | 'exposure_chart.days_on_market' | 'exposure_chart.min_sqft' | 'exposure_chart.sqft' | 'exposure_chart.max_sqft' | 'exposure_chart.min_market_rent' | 'exposure_chart.market_rent' | 'exposure_chart.max_market_rent' | 'exposure_chart.rent_psf' | 'exposure_chart.effective_rent' | 'exposure_chart.effective_rent_psf' | 'exposure_chart.concession_amount' | 'exposure_chart.total_concession_amount' | 'exposure_chart.concession_percent' | 'exposure_chart.trend' | 'exposure_chart.label' | 'exposure_chart.address' | 'exposure_chart.avg_rent' | 'exposure_chart.actions' | 'exposure_chart.number_listings' | 'exposure_chart.renewal_percent' | 'exposure_chart.tradeout_percent' | 'exposure_chart.number_apps_to_cancels' | 'exposure_chart.cancel_percent' | 'exposure_chart.leased_date' | 'exposure_chart.bed' | 'exposure_chart.floorplan_name' | 'fees.similarity' | 'fees.estimated_occupancy' | 'fees.exposure_percent' | 'fees.year_built' | 'fees.number_units' | 'fees.number_stories' | 'fees.number_leased' | 'fees.currently_available' | 'fees.days_on_market' | 'fees.min_sqft' | 'fees.sqft' | 'fees.max_sqft' | 'fees.min_market_rent' | 'fees.market_rent' | 'fees.max_market_rent' | 'fees.rent_psf' | 'fees.effective_rent' | 'fees.effective_rent_psf' | 'fees.concession_amount' | 'fees.total_concession_amount' | 'fees.concession_percent' | 'fees.trend' | 'fees.label' | 'fees.address' | 'fees.avg_rent' | 'fees.actions' | 'fees.number_listings' | 'fees.renewal_percent' | 'fees.tradeout_percent' | 'fees.number_apps_to_cancels' | 'fees.cancel_percent' | 'fees.leased_date' | 'fees.bed' | 'fees.floorplan_name' | 'financial_analysis.similarity' | 'financial_analysis.estimated_occupancy' | 'financial_analysis.exposure_percent' | 'financial_analysis.year_built' | 'financial_analysis.number_units' | 'financial_analysis.number_stories' | 'financial_analysis.number_leased' | 'financial_analysis.currently_available' | 'financial_analysis.days_on_market' | 'financial_analysis.min_sqft' | 'financial_analysis.sqft' | 'financial_analysis.max_sqft' | 'financial_analysis.min_market_rent' | 'financial_analysis.market_rent' | 'financial_analysis.max_market_rent' | 'financial_analysis.rent_psf' | 'financial_analysis.effective_rent' | 'financial_analysis.effective_rent_psf' | 'financial_analysis.concession_amount' | 'financial_analysis.total_concession_amount' | 'financial_analysis.concession_percent' | 'financial_analysis.trend' | 'financial_analysis.label' | 'financial_analysis.address' | 'financial_analysis.avg_rent' | 'financial_analysis.actions' | 'financial_analysis.number_listings' | 'financial_analysis.renewal_percent' | 'financial_analysis.tradeout_percent' | 'financial_analysis.number_apps_to_cancels' | 'financial_analysis.cancel_percent' | 'financial_analysis.leased_date' | 'financial_analysis.bed' | 'financial_analysis.floorplan_name' | 'finishes.similarity' | 'finishes.estimated_occupancy' | 'finishes.exposure_percent' | 'finishes.year_built' | 'finishes.number_units' | 'finishes.number_stories' | 'finishes.number_leased' | 'finishes.currently_available' | 'finishes.days_on_market' | 'finishes.min_sqft' | 'finishes.sqft' | 'finishes.max_sqft' | 'finishes.min_market_rent' | 'finishes.market_rent' | 'finishes.max_market_rent' | 'finishes.rent_psf' | 'finishes.effective_rent' | 'finishes.effective_rent_psf' | 'finishes.concession_amount' | 'finishes.total_concession_amount' | 'finishes.concession_percent' | 'finishes.trend' | 'finishes.label' | 'finishes.address' | 'finishes.avg_rent' | 'finishes.actions' | 'finishes.number_listings' | 'finishes.renewal_percent' | 'finishes.tradeout_percent' | 'finishes.number_apps_to_cancels' | 'finishes.cancel_percent' | 'finishes.leased_date' | 'finishes.bed' | 'finishes.floorplan_name' | 'forecasting.similarity' | 'forecasting.estimated_occupancy' | 'forecasting.exposure_percent' | 'forecasting.year_built' | 'forecasting.number_units' | 'forecasting.number_stories' | 'forecasting.number_leased' | 'forecasting.currently_available' | 'forecasting.days_on_market' | 'forecasting.min_sqft' | 'forecasting.sqft' | 'forecasting.max_sqft' | 'forecasting.min_market_rent' | 'forecasting.market_rent' | 'forecasting.max_market_rent' | 'forecasting.rent_psf' | 'forecasting.effective_rent' | 'forecasting.effective_rent_psf' | 'forecasting.concession_amount' | 'forecasting.total_concession_amount' | 'forecasting.concession_percent' | 'forecasting.trend' | 'forecasting.label' | 'forecasting.address' | 'forecasting.avg_rent' | 'forecasting.actions' | 'forecasting.number_listings' | 'forecasting.renewal_percent' | 'forecasting.tradeout_percent' | 'forecasting.number_apps_to_cancels' | 'forecasting.cancel_percent' | 'forecasting.leased_date' | 'forecasting.bed' | 'forecasting.floorplan_name' | 'future_availability.similarity' | 'future_availability.estimated_occupancy' | 'future_availability.exposure_percent' | 'future_availability.year_built' | 'future_availability.number_units' | 'future_availability.number_stories' | 'future_availability.number_leased' | 'future_availability.currently_available' | 'future_availability.days_on_market' | 'future_availability.min_sqft' | 'future_availability.sqft' | 'future_availability.max_sqft' | 'future_availability.min_market_rent' | 'future_availability.market_rent' | 'future_availability.max_market_rent' | 'future_availability.rent_psf' | 'future_availability.effective_rent' | 'future_availability.effective_rent_psf' | 'future_availability.concession_amount' | 'future_availability.total_concession_amount' | 'future_availability.concession_percent' | 'future_availability.trend' | 'future_availability.label' | 'future_availability.address' | 'future_availability.avg_rent' | 'future_availability.actions' | 'future_availability.number_listings' | 'future_availability.renewal_percent' | 'future_availability.tradeout_percent' | 'future_availability.number_apps_to_cancels' | 'future_availability.cancel_percent' | 'future_availability.leased_date' | 'future_availability.bed' | 'future_availability.floorplan_name' | 'lease_terms.similarity' | 'lease_terms.estimated_occupancy' | 'lease_terms.exposure_percent' | 'lease_terms.year_built' | 'lease_terms.number_units' | 'lease_terms.number_stories' | 'lease_terms.number_leased' | 'lease_terms.currently_available' | 'lease_terms.days_on_market' | 'lease_terms.min_sqft' | 'lease_terms.sqft' | 'lease_terms.max_sqft' | 'lease_terms.min_market_rent' | 'lease_terms.market_rent' | 'lease_terms.max_market_rent' | 'lease_terms.rent_psf' | 'lease_terms.effective_rent' | 'lease_terms.effective_rent_psf' | 'lease_terms.concession_amount' | 'lease_terms.total_concession_amount' | 'lease_terms.concession_percent' | 'lease_terms.trend' | 'lease_terms.label' | 'lease_terms.address' | 'lease_terms.avg_rent' | 'lease_terms.actions' | 'lease_terms.number_listings' | 'lease_terms.renewal_percent' | 'lease_terms.tradeout_percent' | 'lease_terms.number_apps_to_cancels' | 'lease_terms.cancel_percent' | 'lease_terms.leased_date' | 'lease_terms.bed' | 'lease_terms.floorplan_name' | 'market_alerts.similarity' | 'market_alerts.estimated_occupancy' | 'market_alerts.exposure_percent' | 'market_alerts.year_built' | 'market_alerts.number_units' | 'market_alerts.number_stories' | 'market_alerts.number_leased' | 'market_alerts.currently_available' | 'market_alerts.days_on_market' | 'market_alerts.min_sqft' | 'market_alerts.sqft' | 'market_alerts.max_sqft' | 'market_alerts.min_market_rent' | 'market_alerts.market_rent' | 'market_alerts.max_market_rent' | 'market_alerts.rent_psf' | 'market_alerts.effective_rent' | 'market_alerts.effective_rent_psf' | 'market_alerts.concession_amount' | 'market_alerts.total_concession_amount' | 'market_alerts.concession_percent' | 'market_alerts.trend' | 'market_alerts.label' | 'market_alerts.address' | 'market_alerts.avg_rent' | 'market_alerts.actions' | 'market_alerts.number_listings' | 'market_alerts.renewal_percent' | 'market_alerts.tradeout_percent' | 'market_alerts.number_apps_to_cancels' | 'market_alerts.cancel_percent' | 'market_alerts.leased_date' | 'market_alerts.bed' | 'market_alerts.floorplan_name' | 'price_recommendation.similarity' | 'price_recommendation.estimated_occupancy' | 'price_recommendation.exposure_percent' | 'price_recommendation.year_built' | 'price_recommendation.number_units' | 'price_recommendation.number_stories' | 'price_recommendation.number_leased' | 'price_recommendation.currently_available' | 'price_recommendation.days_on_market' | 'price_recommendation.min_sqft' | 'price_recommendation.sqft' | 'price_recommendation.max_sqft' | 'price_recommendation.min_market_rent' | 'price_recommendation.market_rent' | 'price_recommendation.max_market_rent' | 'price_recommendation.rent_psf' | 'price_recommendation.effective_rent' | 'price_recommendation.effective_rent_psf' | 'price_recommendation.concession_amount' | 'price_recommendation.total_concession_amount' | 'price_recommendation.concession_percent' | 'price_recommendation.trend' | 'price_recommendation.label' | 'price_recommendation.address' | 'price_recommendation.avg_rent' | 'price_recommendation.actions' | 'price_recommendation.number_listings' | 'price_recommendation.renewal_percent' | 'price_recommendation.tradeout_percent' | 'price_recommendation.number_apps_to_cancels' | 'price_recommendation.cancel_percent' | 'price_recommendation.leased_date' | 'price_recommendation.bed' | 'price_recommendation.floorplan_name' | 'property_rankings_chart.similarity' | 'property_rankings_chart.estimated_occupancy' | 'property_rankings_chart.exposure_percent' | 'property_rankings_chart.year_built' | 'property_rankings_chart.number_units' | 'property_rankings_chart.number_stories' | 'property_rankings_chart.number_leased' | 'property_rankings_chart.currently_available' | 'property_rankings_chart.days_on_market' | 'property_rankings_chart.min_sqft' | 'property_rankings_chart.sqft' | 'property_rankings_chart.max_sqft' | 'property_rankings_chart.min_market_rent' | 'property_rankings_chart.market_rent' | 'property_rankings_chart.max_market_rent' | 'property_rankings_chart.rent_psf' | 'property_rankings_chart.effective_rent' | 'property_rankings_chart.effective_rent_psf' | 'property_rankings_chart.concession_amount' | 'property_rankings_chart.total_concession_amount' | 'property_rankings_chart.concession_percent' | 'property_rankings_chart.trend' | 'property_rankings_chart.label' | 'property_rankings_chart.address' | 'property_rankings_chart.avg_rent' | 'property_rankings_chart.actions' | 'property_rankings_chart.number_listings' | 'property_rankings_chart.renewal_percent' | 'property_rankings_chart.tradeout_percent' | 'property_rankings_chart.number_apps_to_cancels' | 'property_rankings_chart.cancel_percent' | 'property_rankings_chart.leased_date' | 'property_rankings_chart.bed' | 'property_rankings_chart.floorplan_name' | 'recommendation_highlights.similarity' | 'recommendation_highlights.estimated_occupancy' | 'recommendation_highlights.exposure_percent' | 'recommendation_highlights.year_built' | 'recommendation_highlights.number_units' | 'recommendation_highlights.number_stories' | 'recommendation_highlights.number_leased' | 'recommendation_highlights.currently_available' | 'recommendation_highlights.days_on_market' | 'recommendation_highlights.min_sqft' | 'recommendation_highlights.sqft' | 'recommendation_highlights.max_sqft' | 'recommendation_highlights.min_market_rent' | 'recommendation_highlights.market_rent' | 'recommendation_highlights.max_market_rent' | 'recommendation_highlights.rent_psf' | 'recommendation_highlights.effective_rent' | 'recommendation_highlights.effective_rent_psf' | 'recommendation_highlights.concession_amount' | 'recommendation_highlights.total_concession_amount' | 'recommendation_highlights.concession_percent' | 'recommendation_highlights.trend' | 'recommendation_highlights.label' | 'recommendation_highlights.address' | 'recommendation_highlights.avg_rent' | 'recommendation_highlights.actions' | 'recommendation_highlights.number_listings' | 'recommendation_highlights.renewal_percent' | 'recommendation_highlights.tradeout_percent' | 'recommendation_highlights.number_apps_to_cancels' | 'recommendation_highlights.cancel_percent' | 'recommendation_highlights.leased_date' | 'recommendation_highlights.bed' | 'recommendation_highlights.floorplan_name' | 'rent_trend.similarity' | 'rent_trend.estimated_occupancy' | 'rent_trend.exposure_percent' | 'rent_trend.year_built' | 'rent_trend.number_units' | 'rent_trend.number_stories' | 'rent_trend.number_leased' | 'rent_trend.currently_available' | 'rent_trend.days_on_market' | 'rent_trend.min_sqft' | 'rent_trend.sqft' | 'rent_trend.max_sqft' | 'rent_trend.min_market_rent' | 'rent_trend.market_rent' | 'rent_trend.max_market_rent' | 'rent_trend.rent_psf' | 'rent_trend.effective_rent' | 'rent_trend.effective_rent_psf' | 'rent_trend.concession_amount' | 'rent_trend.total_concession_amount' | 'rent_trend.concession_percent' | 'rent_trend.trend' | 'rent_trend.label' | 'rent_trend.address' | 'rent_trend.avg_rent' | 'rent_trend.actions' | 'rent_trend.number_listings' | 'rent_trend.renewal_percent' | 'rent_trend.tradeout_percent' | 'rent_trend.number_apps_to_cancels' | 'rent_trend.cancel_percent' | 'rent_trend.leased_date' | 'rent_trend.bed' | 'rent_trend.floorplan_name' | 'specials_concessions.similarity' | 'specials_concessions.estimated_occupancy' | 'specials_concessions.exposure_percent' | 'specials_concessions.year_built' | 'specials_concessions.number_units' | 'specials_concessions.number_stories' | 'specials_concessions.number_leased' | 'specials_concessions.currently_available' | 'specials_concessions.days_on_market' | 'specials_concessions.min_sqft' | 'specials_concessions.sqft' | 'specials_concessions.max_sqft' | 'specials_concessions.min_market_rent' | 'specials_concessions.market_rent' | 'specials_concessions.max_market_rent' | 'specials_concessions.rent_psf' | 'specials_concessions.effective_rent' | 'specials_concessions.effective_rent_psf' | 'specials_concessions.concession_amount' | 'specials_concessions.total_concession_amount' | 'specials_concessions.concession_percent' | 'specials_concessions.trend' | 'specials_concessions.label' | 'specials_concessions.address' | 'specials_concessions.avg_rent' | 'specials_concessions.actions' | 'specials_concessions.number_listings' | 'specials_concessions.renewal_percent' | 'specials_concessions.tradeout_percent' | 'specials_concessions.number_apps_to_cancels' | 'specials_concessions.cancel_percent' | 'specials_concessions.leased_date' | 'specials_concessions.bed' | 'specials_concessions.floorplan_name' | 'unit_details.similarity' | 'unit_details.estimated_occupancy' | 'unit_details.exposure_percent' | 'unit_details.year_built' | 'unit_details.number_units' | 'unit_details.number_stories' | 'unit_details.number_leased' | 'unit_details.currently_available' | 'unit_details.days_on_market' | 'unit_details.min_sqft' | 'unit_details.sqft' | 'unit_details.max_sqft' | 'unit_details.min_market_rent' | 'unit_details.market_rent' | 'unit_details.max_market_rent' | 'unit_details.rent_psf' | 'unit_details.effective_rent' | 'unit_details.effective_rent_psf' | 'unit_details.concession_amount' | 'unit_details.total_concession_amount' | 'unit_details.concession_percent' | 'unit_details.trend' | 'unit_details.label' | 'unit_details.address' | 'unit_details.avg_rent' | 'unit_details.actions' | 'unit_details.number_listings' | 'unit_details.renewal_percent' | 'unit_details.tradeout_percent' | 'unit_details.number_apps_to_cancels' | 'unit_details.cancel_percent' | 'unit_details.leased_date' | 'unit_details.bed' | 'unit_details.floorplan_name' | 'unit_metrics.similarity' | 'unit_metrics.estimated_occupancy' | 'unit_metrics.exposure_percent' | 'unit_metrics.year_built' | 'unit_metrics.number_units' | 'unit_metrics.number_stories' | 'unit_metrics.number_leased' | 'unit_metrics.currently_available' | 'unit_metrics.days_on_market' | 'unit_metrics.min_sqft' | 'unit_metrics.sqft' | 'unit_metrics.max_sqft' | 'unit_metrics.min_market_rent' | 'unit_metrics.market_rent' | 'unit_metrics.max_market_rent' | 'unit_metrics.rent_psf' | 'unit_metrics.effective_rent' | 'unit_metrics.effective_rent_psf' | 'unit_metrics.concession_amount' | 'unit_metrics.total_concession_amount' | 'unit_metrics.concession_percent' | 'unit_metrics.trend' | 'unit_metrics.label' | 'unit_metrics.address' | 'unit_metrics.avg_rent' | 'unit_metrics.actions' | 'unit_metrics.number_listings' | 'unit_metrics.renewal_percent' | 'unit_metrics.tradeout_percent' | 'unit_metrics.number_apps_to_cancels' | 'unit_metrics.cancel_percent' | 'unit_metrics.leased_date' | 'unit_metrics.bed' | 'unit_metrics.floorplan_name' | 'unit_mix_recommendation.similarity' | 'unit_mix_recommendation.estimated_occupancy' | 'unit_mix_recommendation.exposure_percent' | 'unit_mix_recommendation.year_built' | 'unit_mix_recommendation.number_units' | 'unit_mix_recommendation.number_stories' | 'unit_mix_recommendation.number_leased' | 'unit_mix_recommendation.currently_available' | 'unit_mix_recommendation.days_on_market' | 'unit_mix_recommendation.min_sqft' | 'unit_mix_recommendation.sqft' | 'unit_mix_recommendation.max_sqft' | 'unit_mix_recommendation.min_market_rent' | 'unit_mix_recommendation.market_rent' | 'unit_mix_recommendation.max_market_rent' | 'unit_mix_recommendation.rent_psf' | 'unit_mix_recommendation.effective_rent' | 'unit_mix_recommendation.effective_rent_psf' | 'unit_mix_recommendation.concession_amount' | 'unit_mix_recommendation.total_concession_amount' | 'unit_mix_recommendation.concession_percent' | 'unit_mix_recommendation.trend' | 'unit_mix_recommendation.label' | 'unit_mix_recommendation.address' | 'unit_mix_recommendation.avg_rent' | 'unit_mix_recommendation.actions' | 'unit_mix_recommendation.number_listings' | 'unit_mix_recommendation.renewal_percent' | 'unit_mix_recommendation.tradeout_percent' | 'unit_mix_recommendation.number_apps_to_cancels' | 'unit_mix_recommendation.cancel_percent' | 'unit_mix_recommendation.leased_date' | 'unit_mix_recommendation.bed' | 'unit_mix_recommendation.floorplan_name' | 'unit_prices_over_time.similarity' | 'unit_prices_over_time.estimated_occupancy' | 'unit_prices_over_time.exposure_percent' | 'unit_prices_over_time.year_built' | 'unit_prices_over_time.number_units' | 'unit_prices_over_time.number_stories' | 'unit_prices_over_time.number_leased' | 'unit_prices_over_time.currently_available' | 'unit_prices_over_time.days_on_market' | 'unit_prices_over_time.min_sqft' | 'unit_prices_over_time.sqft' | 'unit_prices_over_time.max_sqft' | 'unit_prices_over_time.min_market_rent' | 'unit_prices_over_time.market_rent' | 'unit_prices_over_time.max_market_rent' | 'unit_prices_over_time.rent_psf' | 'unit_prices_over_time.effective_rent' | 'unit_prices_over_time.effective_rent_psf' | 'unit_prices_over_time.concession_amount' | 'unit_prices_over_time.total_concession_amount' | 'unit_prices_over_time.concession_percent' | 'unit_prices_over_time.trend' | 'unit_prices_over_time.label' | 'unit_prices_over_time.address' | 'unit_prices_over_time.avg_rent' | 'unit_prices_over_time.actions' | 'unit_prices_over_time.number_listings' | 'unit_prices_over_time.renewal_percent' | 'unit_prices_over_time.tradeout_percent' | 'unit_prices_over_time.number_apps_to_cancels' | 'unit_prices_over_time.cancel_percent' | 'unit_prices_over_time.leased_date' | 'unit_prices_over_time.bed' | 'unit_prices_over_time.floorplan_name' | 'unit_type_metrics.similarity' | 'unit_type_metrics.estimated_occupancy' | 'unit_type_metrics.exposure_percent' | 'unit_type_metrics.year_built' | 'unit_type_metrics.number_units' | 'unit_type_metrics.number_stories' | 'unit_type_metrics.number_leased' | 'unit_type_metrics.currently_available' | 'unit_type_metrics.days_on_market' | 'unit_type_metrics.min_sqft' | 'unit_type_metrics.sqft' | 'unit_type_metrics.max_sqft' | 'unit_type_metrics.min_market_rent' | 'unit_type_metrics.market_rent' | 'unit_type_metrics.max_market_rent' | 'unit_type_metrics.rent_psf' | 'unit_type_metrics.effective_rent' | 'unit_type_metrics.effective_rent_psf' | 'unit_type_metrics.concession_amount' | 'unit_type_metrics.total_concession_amount' | 'unit_type_metrics.concession_percent' | 'unit_type_metrics.trend' | 'unit_type_metrics.label' | 'unit_type_metrics.address' | 'unit_type_metrics.avg_rent' | 'unit_type_metrics.actions' | 'unit_type_metrics.number_listings' | 'unit_type_metrics.renewal_percent' | 'unit_type_metrics.tradeout_percent' | 'unit_type_metrics.number_apps_to_cancels' | 'unit_type_metrics.cancel_percent' | 'unit_type_metrics.leased_date' | 'unit_type_metrics.bed' | 'unit_type_metrics.floorplan_name' | 'unit_type_table.similarity' | 'unit_type_table.estimated_occupancy' | 'unit_type_table.exposure_percent' | 'unit_type_table.year_built' | 'unit_type_table.number_units' | 'unit_type_table.number_stories' | 'unit_type_table.number_leased' | 'unit_type_table.currently_available' | 'unit_type_table.days_on_market' | 'unit_type_table.min_sqft' | 'unit_type_table.sqft' | 'unit_type_table.max_sqft' | 'unit_type_table.min_market_rent' | 'unit_type_table.market_rent' | 'unit_type_table.max_market_rent' | 'unit_type_table.rent_psf' | 'unit_type_table.effective_rent' | 'unit_type_table.effective_rent_psf' | 'unit_type_table.concession_amount' | 'unit_type_table.total_concession_amount' | 'unit_type_table.concession_percent' | 'unit_type_table.trend' | 'unit_type_table.label' | 'unit_type_table.address' | 'unit_type_table.avg_rent' | 'unit_type_table.actions' | 'unit_type_table.number_listings' | 'unit_type_table.renewal_percent' | 'unit_type_table.tradeout_percent' | 'unit_type_table.number_apps_to_cancels' | 'unit_type_table.cancel_percent' | 'unit_type_table.leased_date' | 'unit_type_table.bed' | 'unit_type_table.floorplan_name' | 'volume_over_time.similarity' | 'volume_over_time.estimated_occupancy' | 'volume_over_time.exposure_percent' | 'volume_over_time.year_built' | 'volume_over_time.number_units' | 'volume_over_time.number_stories' | 'volume_over_time.number_leased' | 'volume_over_time.currently_available' | 'volume_over_time.days_on_market' | 'volume_over_time.min_sqft' | 'volume_over_time.sqft' | 'volume_over_time.max_sqft' | 'volume_over_time.min_market_rent' | 'volume_over_time.market_rent' | 'volume_over_time.max_market_rent' | 'volume_over_time.rent_psf' | 'volume_over_time.effective_rent' | 'volume_over_time.effective_rent_psf' | 'volume_over_time.concession_amount' | 'volume_over_time.total_concession_amount' | 'volume_over_time.concession_percent' | 'volume_over_time.trend' | 'volume_over_time.label' | 'volume_over_time.address' | 'volume_over_time.avg_rent' | 'volume_over_time.actions' | 'volume_over_time.number_listings' | 'volume_over_time.renewal_percent' | 'volume_over_time.tradeout_percent' | 'volume_over_time.number_apps_to_cancels' | 'volume_over_time.cancel_percent' | 'volume_over_time.leased_date' | 'volume_over_time.bed' | 'volume_over_time.floorplan_name' | 'tax_history.similarity' | 'tax_history.estimated_occupancy' | 'tax_history.exposure_percent' | 'tax_history.year_built' | 'tax_history.number_units' | 'tax_history.number_stories' | 'tax_history.number_leased' | 'tax_history.currently_available' | 'tax_history.days_on_market' | 'tax_history.min_sqft' | 'tax_history.sqft' | 'tax_history.max_sqft' | 'tax_history.min_market_rent' | 'tax_history.market_rent' | 'tax_history.max_market_rent' | 'tax_history.rent_psf' | 'tax_history.effective_rent' | 'tax_history.effective_rent_psf' | 'tax_history.concession_amount' | 'tax_history.total_concession_amount' | 'tax_history.concession_percent' | 'tax_history.trend' | 'tax_history.label' | 'tax_history.address' | 'tax_history.avg_rent' | 'tax_history.actions' | 'tax_history.number_listings' | 'tax_history.renewal_percent' | 'tax_history.tradeout_percent' | 'tax_history.number_apps_to_cancels' | 'tax_history.cancel_percent' | 'tax_history.leased_date' | 'tax_history.bed' | 'tax_history.floorplan_name' | 'poi_map.similarity' | 'poi_map.estimated_occupancy' | 'poi_map.exposure_percent' | 'poi_map.year_built' | 'poi_map.number_units' | 'poi_map.number_stories' | 'poi_map.number_leased' | 'poi_map.currently_available' | 'poi_map.days_on_market' | 'poi_map.min_sqft' | 'poi_map.sqft' | 'poi_map.max_sqft' | 'poi_map.min_market_rent' | 'poi_map.market_rent' | 'poi_map.max_market_rent' | 'poi_map.rent_psf' | 'poi_map.effective_rent' | 'poi_map.effective_rent_psf' | 'poi_map.concession_amount' | 'poi_map.total_concession_amount' | 'poi_map.concession_percent' | 'poi_map.trend' | 'poi_map.label' | 'poi_map.address' | 'poi_map.avg_rent' | 'poi_map.actions' | 'poi_map.number_listings' | 'poi_map.renewal_percent' | 'poi_map.tradeout_percent' | 'poi_map.number_apps_to_cancels' | 'poi_map.cancel_percent' | 'poi_map.leased_date' | 'poi_map.bed' | 'poi_map.floorplan_name'> | null;
            sections: Array<Section>;
            name: string;
            organization_id: number;
            id: number;
            user_count: number;
        };
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/group/{groupId}',
            path: {
                'groupId': groupId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param groupId
     * @returns void
     * @throws ApiError
     */
    public deleteOrganizationGroup(
        groupId: number,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/group/{groupId}',
            path: {
                'groupId': groupId,
            },
        });
    }
    /**
     * @param groupId
     * @returns any Ok
     * @throws ApiError
     */
    public setExternal(
        groupId: number,
    ): CancelablePromise<{
        data: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/group/{groupId}/external',
            path: {
                'groupId': groupId,
            },
        });
    }
    /**
     * @param groupId
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public createOrganizationGroupUser(
        groupId: number,
        requestBody: {
            user_ids: Array<string>;
        },
    ): CancelablePromise<{
        data: Array<Pick_UserAttributes_id_or_email_or_created_on_or_organization_id_or_given_name_or_family_name_or_picture_or_group_id_>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/group/{groupId}/groupuser',
            path: {
                'groupId': groupId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param groupId
     * @param userToRemoveId
     * @returns void
     * @throws ApiError
     */
    public deleteOrganizationGroupUser(
        groupId: number,
        userToRemoveId: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/group/{groupId}/groupuser/{userToRemoveId}',
            path: {
                'groupId': groupId,
                'userToRemoveId': userToRemoveId,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public clearCache(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/clear_cache',
        });
    }
    /**
     * @param state
     * @returns any
     * @throws ApiError
     */
    public clearCacheByState(
        state: string,
    ): CancelablePromise<{
        deleted: number;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/clear_cache_by_state',
            query: {
                'state': state,
            },
        });
    }
    /**
     * @returns ControllerResponse_TemplateAIAttributes_Array_ Ok
     * @throws ApiError
     */
    public getAllReportTemplates(): CancelablePromise<ControllerResponse_TemplateAIAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/report/templates',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_TemplateAIAttributes_ Ok
     * @throws ApiError
     */
    public createReportTemplate(
        requestBody: {
            tags?: Array<string>;
            prompt: string;
            name: string;
        },
    ): CancelablePromise<ControllerResponse_TemplateAIAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/report/templates',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param templateId
     * @returns ControllerResponse_TemplateAIAttributes_ Ok
     * @throws ApiError
     */
    public getReportTemplateById(
        templateId: number,
    ): CancelablePromise<ControllerResponse_TemplateAIAttributes_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/report/templates/{templateId}',
            path: {
                'templateId': templateId,
            },
        });
    }
    /**
     * @param templateId
     * @param requestBody
     * @returns ControllerResponse_TemplateAIAttributes_ Ok
     * @throws ApiError
     */
    public updateReportTemplate(
        templateId: number,
        requestBody: {
            tags?: Array<string>;
            prompt?: string;
            name?: string;
        },
    ): CancelablePromise<ControllerResponse_TemplateAIAttributes_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/report/templates/{templateId}',
            path: {
                'templateId': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param templateId
     * @returns ControllerResponse_TemplateAIAttributes_ Ok
     * @throws ApiError
     */
    public deleteReportTemplate(
        templateId: number,
    ): CancelablePromise<ControllerResponse_TemplateAIAttributes_> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/report/templates/{templateId}',
            path: {
                'templateId': templateId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public adminPreviewDataset(
        requestBody: {
            userId: string;
            payload: DatasetPayload;
        },
    ): CancelablePromise<Array<Array<(string | number | boolean) | null>>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/export/preview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public adminSendDatasetEmail(
        requestBody: {
            format: 'csv' | 'jsonl';
            name: string;
            payload: DatasetPayload;
            userId: string;
        },
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/send_email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param organizationId
     * @param formData
     * @returns any Created
     * @throws ApiError
     */
    public createSso(
        organizationId: number,
        formData: {
            certificateFile: Blob;
            connectionName: string;
            issuer: string;
            signinUrl: string;
            domains: string;
        },
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/organization/{organizationId}/sso',
            path: {
                'organizationId': organizationId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param organizationId
     * @returns ControllerResponse__enabled_boolean__ Ok
     * @throws ApiError
     */
    public viewSso(
        organizationId: number,
    ): CancelablePromise<ControllerResponse__enabled_boolean__> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/organization/{organizationId}/sso',
            path: {
                'organizationId': organizationId,
            },
        });
    }
    /**
     * Unsubscribes an email address from all email notification schedules
     * (property reports and datasets). Schedules that become empty after
     * removal are soft-deleted automatically.
     * @param requestBody
     * @returns ControllerResponse__email_string_schedulesModified_number__ Ok
     * @throws ApiError
     */
    public adminUnsubscribeUserEmail(
        requestBody: {
            email: string;
        },
    ): CancelablePromise<ControllerResponse__email_string_schedulesModified_number__> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/unsubscribe_user_email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ControllerResponse_ExcelTemplate_Array_ Ok
     * @throws ApiError
     */
    public listExcelTemplates(): CancelablePromise<ControllerResponse_ExcelTemplate_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/excel-templates',
        });
    }
    /**
     * @param fileName
     * @returns ControllerResponse_string_ Ok
     * @throws ApiError
     */
    public downloadExcelTemplate(
        fileName: string,
    ): CancelablePromise<ControllerResponse_string_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/excel-templates/{fileName}/download',
            path: {
                'fileName': fileName,
            },
        });
    }
    /**
     * @param fileName
     * @param requestBody
     * @returns ControllerResponse__promoted_boolean__ Ok
     * @throws ApiError
     */
    public promoteExcelTemplate(
        fileName: string,
        requestBody: {
            target: 'dev' | 'prod';
        },
    ): CancelablePromise<ControllerResponse__promoted_boolean__> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/excel-templates/{fileName}/promote',
            path: {
                'fileName': fileName,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param fileName
     * @returns ControllerResponse__deleted_boolean__ Ok
     * @throws ApiError
     */
    public deleteExcelTemplate(
        fileName: string,
    ): CancelablePromise<ControllerResponse__deleted_boolean__> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/excel-templates/{fileName}',
            path: {
                'fileName': fileName,
            },
        });
    }
    /**
     * @param formData
     * @returns ControllerResponse__name_string__ Created
     * @throws ApiError
     */
    public uploadExcelTemplate(
        formData: {
            file: Blob;
        },
    ): CancelablePromise<ControllerResponse__name_string__> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/excel-templates/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse__successCount_number_failedUserIds_string_Array__ Ok
     * @throws ApiError
     */
    public bulkRemoveFromOrganization(
        requestBody: {
            transfer_user_id?: string;
            user_ids: Array<string>;
            organization_id: number;
        },
    ): CancelablePromise<ControllerResponse__successCount_number_failedUserIds_string_Array__> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/bulk_remove_from_organization',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param organizationId
     * @param requestBody
     * @returns ControllerResponse__enabled_boolean__ Ok
     * @throws ApiError
     */
    public setSsoStatus(
        organizationId: number,
        requestBody: {
            enabled: boolean;
        },
    ): CancelablePromise<ControllerResponse__enabled_boolean__> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/organization/{organizationId}/set_sso_status',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
